<template>
  
    <div class="cfa-root-head d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="text-center">
            <button @click="changeMenuMode2" class="btn cfa-btn-primary btn-icon" id="cfa-nav-bottom-swiper">
              <i class="fa fa-bars"></i>
            </button>
        
          </div>
          <!--<search-bar cssStyle="padding: 1.2em 1.3em 1.2em 3.1em; height: 3em;"></search-bar>-->
        </div>
        
        <div class="d-flex align-items-center">
          <!-- <select-button @action="changeLang" :dropDownLabel="['🇨🇵️ French', '🇺🇸️ English']" :dropDownLink="['fr', 'en']" uid="cfa-lang-swiper-bottom" :showArrow="false" cssStyle="border: none !important; position: relative !important;right: 1em;width: 10em;bottom: 0em;" cssClass="d-block"></select-button>
          <button @click="openNotifBox = true" class="cfa-discret-btn">
            <img width="15" src="../../assets/Icons/All_Icon/notif.png" alt="notification icon" />
          </button> -->
          <AvatartType2 @getLogoutConfirmatiion="openLogoutBox = true" :refresh="refresh"
            :image="defaultAvatar"></AvatartType2>
        </div>
        <transition name="fade" appear mode="out-in">
          <scalable-modal display-mode="flex" @callback="tryLogout" :notifyTaskDone="callbackPayload"
          @close="openLogoutBox = false" :open="openLogoutBox" :advancedControl="true" validationButtonText="Oui"
          exitButtonText="Non" :style="'width: 30em; '" uid="cfa-modal-002">
          <template v-slot:content>
            <!--<p class="mb-0" style="font-size: 3em;"> ⚠️ </p>-->
            <div>
              <img src="@/assets/img/gif/logout.gif" style="width: 9em;" />
            </div>
            <h2 class="mb-0">Déconnexion</h2>
            <p>Êtes vous sure?</p>
            <div><br><br></div>
          </template>
        </scalable-modal>
        </transition>
      </div>
</template>

<script setup>
import  { ref } from 'vue'
//import NavButton from '@/components/shared/button/NavButton.vue'
import AvatartType2 from '@/components/shared/avatar/AvatartType2.vue'
//import SelectButton from '@/components/shared/button/SelectButton.vue'
import ScalableModal from '@/components/shared/modal/ScalableModalAlone.vue'

import { getAPI } from '@/axios-api.js'


const openLogoutBox = ref(false)
const menuMode = ref('LARGE')
//const menuMode2 = ref('LARGES')
//const showLogo = ref('')
//const primary = ref('')
//const organisationData = ref({})
//const secondary = ref('')
//const showFavicon = ref('')
const callbackPayload = ref(null)
//const alertMe = ref(false)
//const gAlertMessage = ref('')
//const gAlertType = ref('')
//const waitingAPIResponse = ref(false)
const defaultAvatar = ref('/images/defaultImage.png')
//const typeAccount = ref(localStorage.getItem('type_account'))
const changeMenuMode2 = () => {
      const sideNav = document.getElementById('cfa-side-navbar')
      const rootContent = document.getElementById('side-layout')
      const largeNavElements = document.querySelectorAll('.large-nav')

      // Toggle between expanded and collapsed states
      const toggleNavbar = (isCollapsed) => {
        const width = isCollapsed ? "60px" : "100%"
        
        sideNav?.classList.toggle('collapsed', isCollapsed)
        sideNav?.classList.toggle('no-collapse', !isCollapsed)
        
        // Toggle visibility of large-nav elements
        largeNavElements.forEach(element => {
          element.style.display = isCollapsed ? 'none' : ''
          element.style.opacity = isCollapsed ? '0' : '1'
        })
        
        if (sideNav && rootContent) {
          sideNav.style.width = width
          rootContent?.classList.toggle('side-layout-wide', isCollapsed)
        }
      }

      if (menuMode.value === 'LARGE') {
        toggleNavbar(true)
        menuMode.value = 'SHORT'
        localStorage.setItem('menuMode', 'SHORT')
      } else {
        toggleNavbar(false)
        menuMode.value = 'LARGE'
        localStorage.setItem('menuMode', 'LARGE')
      }
}
const tryLogout = () => {
      getAPI.post('accounts/logout', {
        refresh_token: localStorage.getItem('refresh_token'),
      })
        .then(response => {
          if (response.status == 204) {
            localStorage.clear();
            callbackPayload.value = 'A bientôt' + '::' + Date.now();
            setTimeout(() => {
              //waitingAPIResponse = false
              let a = document.createElement('a');
              a.href = "/"
              a.click()
              a.remove()
            }, 2000);
            //window.location.href = "https://www.google.com";
          }
          else {
            openLogoutBox.value  = false
            this.displayError('Oups ! something went wrong.', 'alert-no')
          }
        })
        .catch(error => {
          localStorage.clear();
          setTimeout(() => {
            //this.waitingAPIResponse = false
            let a = document.createElement('a');
            a.href = "/"
            a.click()
            a.remove()
          }, 2000);
          if (error.response.status == 400) {
            // error
          } else if (error.response) {
            this.displayError(error.response.data.message, 'alert-no', 10000)
          }
          else if (error.request) {
            this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
          }
          else {
            this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
          }
          openLogoutBox.value = false
        })
    }
</script>

<style lang="scss" scoped>
  @import "@/assets/css/app.scss";
@import "@/assets/css/style.css";
@import "@/assets/scss/index.scss";
.cfa-menu-mobile {
  padding: .6em .9em;
}

.cfa-side-logo {
  width: 90%;
  padding: 0em;
}

.cfa-wrapper {
  min-height: 100vh;
  background-color: #f6f9fe;
  display: flex;
  padding: 1.2em;
}

.cfa-navbar {
  width: 24vw;
  background-color:rgb(255, 255, 255);
  padding: 20px 10px;
  min-height: 100vh;
  position: sticky;
  top: 0;
  box-shadow: 3px 30px 50px -2px rgba(1, 11, 60, .1);
}
.cfa-navbar img {
  max-width: unset;
}
.cfa-primary{
  color:rgb(250, 37, 37);
}
.nav-container {
  padding: 20px 10px;
}

.for-mobile {
  display: none;
}

@media only screen and (max-width: 991px) {
  .cfa-navbar {
    width: 60px;
  }
  .nav-container {
    padding: 20px 0px;
  }
}

@media only screen and (max-width: 600px) {
  #cfa-side-navbar {
    display: none;
  }
  .cfa-navbar {
    width: 60px;
  }
  .for-mobile {
    display: block;
  }

  .for-desktop {
    display: none;
  }

  .hidden {
    display: none;
  }
}

.cfa-root-content {
  padding: 0px 2em;
  width: 100%;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1024px) {
  .cfa-root-content {
    width: calc(100vw - 26vw);
    display: flex;
    flex-direction: column;
  }
}

.cfa-discret-btn {
  border: none;
  background-color: transparent;
  border-radius: .5em;
}

.cfa-discret-btn:hover {
  border: 1px solid #fff;
}

.cfa-discret-btn {
  background-color: #fff;
}

.cfa-favicon-logo {
  position: relative;
  left: 0.3em;
  height: auto !important;
}

.cfa-root-body {
  min-height: calc(100vh - 60px);
}

.cfa-go-back:hover {
  background-color: #585f73;
  color: #fff;
}

/* Grisage de Ressources et Rendez-vous expert */
.disabled {
  position: relative;
  cursor: allowed;
}

.disabled::before {
  content: "";
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px;
  border-radius: 5px;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s;
}

.disabled:hover::before {
  visibility: visible;
  opacity: 1;
}
.collapsed .cfa-logo{
  display: none !important;
}
.no-collapse .cfa-favicon-logo{
  display: none !important;
}
</style>
